import { RuntimeModel, http } from '@kunlun/dependencies';
import { TIssuingMethod } from '../../../../hooks';
import { graphqlQueryFormatter, stringifyToGraphql } from '../../../../utils/serialize';
const mainDataGql = `
distributionChannelId
shop {
  id
  code
}
buyerRemark
sellerRemark
bizType
orderType
tradeOrderId 
totalAmount
tradeOrderCode
tradeOrderOutCode
buyerPartnerName 
buyerPartnerId 
sellerPartnerId
hasIssuingMethod
ariesIssuingMethodEnum
ariesIssuingMethodOptions
tmsDeliveryMethod
deliveryAreaTypeEnum
deliveryAddressTypeEnum
consigneeName 
consigneePhone 
salesOfficeId
customerServiceDeliveryTime
logisticsCode
deliveryAddressCopy {
  labelTitle
  id
}
deliveryAddress {
  id
  contactMan
  contactPhone
  contactLandPhone
  contactEmail
  zipCode
  address {
    id
    street2
    fullAddress
    countryCode
    countryName
    provinceCode
    provinceName
    cityCode
    cityName
    districtName
    districtCode
    streetCode
    streetName
  }
  detailAddress
  addressId
}
tmsOrderDetails {
  ruleName
  characteristics
  assemblyItemDisplay
  isAssemblyItem
  planAllocNum
  orderDetailClosedNum
  fullAddress
  contactMan
  purchasePlanNum
  settlementAmount
  settlementAmountTrade
  orderDetailItemNum
  orderDetailRebatePayAmount
  actualAmount
  factoryPrice
  rebatePayAmount
  saleSkuId
  actualUnitPrice
  saleSkuTplId
  itemtplCode
  isSelected
  itemOutCode 
  itemName 
  productBelong
  settlementDeductionRate 
  settlementPrice 
  availableNum
  deliAriesInventoryStatusEnum
  undeliveredNum
  deliveredNum 
  operateNum 
  appliedPlanNum
  materialGroupName
  tradeOrderDetailId
  productOutCode
  tradeOrderOptions
  itemColor
  lineNumber
  deliverText
  deliveryWarehouseCode
  deliveryFactoryCode
  sellerDeliveryWarehouse {
    id
    name
    code
  }
  itemSpecifications {
    id
    unitName
    unitCode
    conversionRules
    count
    pcsCount
  }
}
`;
const mainDataGqlCopy = `
distributionChannelId
shop {
  id
  code
}
buyerRemark
sellerRemark
bizType
orderType
tradeOrderId 
totalAmount
tradeOrderCode 
buyerPartnerName 
buyerPartnerId 
sellerPartnerId
hasIssuingMethod
ariesIssuingMethodEnum
ariesIssuingMethodOptions
tmsDeliveryMethod
deliveryAreaTypeEnum
deliveryAddressTypeEnum
consigneeName 
consigneePhone 
salesOfficeId
customerServiceDeliveryTime
logisticsCode
deliveryAddressCopy {
  labelTitle
  id
}
deliveryAddress {
  id
  contactMan
  contactPhone
  contactLandPhone
  contactEmail
  zipCode
  address {
    id
    street2
    fullAddress
    countryCode
    countryName
    provinceCode
    provinceName
    cityCode
    cityName
    districtName
    districtCode
    streetCode
    streetName
  }
  detailAddress
  addressId
}
tmsOrderDetails {
  assemblyItemDisplay
  isAssemblyItem
  planAllocNum
  orderDetailClosedNum
  fullAddress
  contactMan
  purchasePlanNum
  settlementAmount
  orderDetailItemNum
  orderDetailRebatePayAmount
  actualAmount
  factoryPrice
  rebatePayAmount
  saleSkuId
  actualUnitPrice
  saleSkuTplId
  itemtplCode
  isSelected
  itemOutCode 
  itemName 
  productBelong 
  settlementDeductionRate 
  settlementPrice 
  availableNum
  deliAriesInventoryStatusEnum
  undeliveredNum
  deliveredNum 
  operateNum 
  appliedPlanNum
  materialGroupName
  tradeOrderDetailId
  productOutCode
  tradeOrderOptions
  itemColor
  lineNumber
  sellerDeliveryWarehouse {
    id
    name
    code
  }
  itemSpecifications {
    id
    unitName
    unitCode
    conversionRules
    count
    pcsCount
  }
}
`;

export async function tmsOrderConstruct(
  rModel: RuntimeModel,
  params: {
    tradeOrderId: any;
  }
) {
  const gql = `
    mutation {
      deliAriesSellerCreateTmsOrderMutation {
        tmsOrderConstructV2(tmsOrder: { 
          tradeOrderId: "${params.tradeOrderId}", 
          searchKey: "",
          warehouseDeliveryTypeEnum: PARTS_AND_ALL
        }) {
          ${mainDataGql}
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));
  return res.data.deliAriesSellerCreateTmsOrderMutation.tmsOrderConstructV2;
}

export async function tmsFreshInventoryConstruct(
  rModel: RuntimeModel,
  params: {
    tradeOrderCode: any;
    tmsOrderDetails: any[];
  }
) {
  const gql = `
        mutation {
        deliAriesSellerCreateTmsOrderMutation {
          freshInventory(
            tmsOrder: ${stringifyToGraphql(params, enumList)}
          ){
            id
          }
        }
      }
  `;

  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderMutation.freshInventory;
}

export async function fetchPurchasingPlan(
  rModel: RuntimeModel,
  params: {
    tradeOrderCode: string;
    planCurrentPage: number;
    planPageSize: number;
  }
) {
  const gql = `
    mutation {
      deliAriesSellerCreateTmsOrderMutation {
        fetchPurchasingPlan (
          deliAriesSellerCreateTmsOrder: ${stringifyToGraphql(params)}
        ) {
          purchasingPlanList {
            id
            code
            purchasedNumTotal
            expectedDeliveryTime
            remark
            sellerDesc
            consigneeName
            consigneePhone
            consigneeFullAddress
            issuingMethod
            ariesTmsDeliveryMethodEnum
            deliveryAreaTypeEnum
            deliAriesPurchasingPlanDetails{
              id
              tradeDetailId
            }
            ariesLogisticsProvider {
              id
              name
              code
            }
            deliveryAddress {
              id
              contactMan
              contactPhone
              contactLandPhone
              contactEmail
              zipCode
              address {
                id
                street2
                fullAddress
                countryCode
                countryName
                provinceCode
                provinceName
                cityCode
                cityName
                districtName
                districtCode
                streetCode
                streetName
              }
              detailAddress
              addressId
            }
          }
          planCurrentPage
          planPageSize
          totalPlanNum
          purchasingPlanCode
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderMutation.fetchPurchasingPlan;
}

export async function fetchPurchasingPlanDetail(
  rModel: RuntimeModel,
  params: {
    purchasingPlanId: string;
  }
) {
  const gql = `
    mutation {
      deliAriesSellerCreateTmsOrderMutation {
        fetchPurchasingPlanOne(purchasingPlanReq: ${stringifyToGraphql(params, ['purchasingPlanId'])}) {
          id
          deliAriesPurchasingPlanDetails {
            id
            tradeDetailId
            itemPurchasingNum
            allocedNum
            unAllocedNum # 当前要货待发数量(PCS)
          }
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderMutation.fetchPurchasingPlanOne;
}

export async function queryAddressList(
  rModel: RuntimeModel,
  params: {
    buyerPartnerId: any;
  }
) {
  const gql = `
    query {
      ariesCoreCreateOrderDeliveryAddressQuery {
        queryPage(
          page: {
            currentPage: 1,
            size: 2000
          }
          queryWrapper: {
            rsql: "relationId=='${params.buyerPartnerId}'"
          }
        ) {
          content {
            labelTitle
            id
          }
          size
          totalPages
          totalElements
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.ariesCoreCreateOrderDeliveryAddressQuery.queryPage;
}

export async function queryLogisticsProviderList(rModel: RuntimeModel) {
  const gql = `
    query {
      deliAriesSellerLogisticsProviderQuery {
        queryPage(
          page: { currentPage: 1, size: 1000 }
          queryWrapper: {
            rsql: "(1==1) and (1==1)"
            queryData: {
              code: null
              outLogisticsCode: null
              name: null
              contact: null
            }
          }
        ) {
          content {
            id
            code
            outLogisticsCode
            name
            dataStatus
            contact
            contactPhone
            createDate
            writeDate
          }
          totalPages
          totalElements
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerLogisticsProviderQuery.queryPage;
}

const enumList = [
  'deliAriesInventoryStatusEnum',
  'orderType',
  'bizType',
  'tmsDeliveryMethod',
  'warehouseDeliveryTypeEnum',
  'deliveryAddressTypeEnum',
  'ariesIssuingMethodEnum',
  'deliveryAreaTypeEnum',
  'tradeOrderOptions'
];

export async function mirrorConstructMutation(rModel: RuntimeModel, params: Record<any, any>) {
  const gql = `
    mutation {
      deliAriesSellerCreateTmsOrderMutation {
        tmsOrderDetailsConstructMirror (
          tmsOrder: ${stringifyToGraphql(params, enumList)}
        ) {
          purchasingPlanCode
          ${mainDataGqlCopy}
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderMutation.tmsOrderDetailsConstructMirror;
}

export async function mirrorConstructQuery(rModel: RuntimeModel, params: Record<any, any>) {
  const gql = `
    query {
      deliAriesSellerCreateTmsOrderQuery {
        constructMirrorV2 (
          tmsOrder: ${stringifyToGraphql(params, enumList, undefined, true)}
        ) {
          purchasingPlanCode
          ${mainDataGql}
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderQuery.constructMirrorV2;
}

export async function queryWareHouse(
  rModel: RuntimeModel,
  params: {
    searchKey: string;
    saleSkuTplId?: string;
    saleSkuTplIdList?: string;
    itemOutCode?:string;
    shopId: string;
    salesOfficeId: string;
    buyerPartnerId?: string;
    distributionChannelId: string;
    code: string;
    name: string;
    bizType: any;
    itemTplCode?: any;
    tradeOrderCode: any;
    resourceAddress?: {
      countryCode?: any;
      countryName?: any;
      provinceCode?: any;
      provinceName?: any;
      cityCode?: any;
      cityName?: any;
      districtName?: any;
      districtCode?: any;
      streetCode?: any;
      streetName?: any;
      street2?: any;
    };
    deliveryAddress?: {
      address: {
        countryCode?: any;
        countryName?: any;
        provinceCode?: any;
        provinceName?: any;
        cityCode?: any;
        cityName?: any;
        districtName?: any;
        districtCode?: any;
        streetCode?: any;
        streetName?: any;
        street2?: any;
      };
    };
    ariesIssuingMethodEnum?: string;
    warehouseDeliveryTypeEnum?: string;
  }
) {
  const modelStr = params.saleSkuTplId
    ? 'deliAriesSellerCreateTmsOrderMutation'
    : 'deliAriesSellerOutWarehouseMutation';
  const fnStr = params.saleSkuTplId ? 'queryWarehouse' : 'queryV2';
  if (!params.saleSkuTplId) {
    delete params.buyerPartnerId;
    delete params.itemTplCode;
  }
  const gql = `
    mutation {
      ${modelStr} {
        ${fnStr}(
          query: ${stringifyToGraphql(params, ['bizType', 'ariesIssuingMethodEnum', 'warehouseDeliveryTypeEnum'])}
        ) {
          id
          code
          name
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));
  return res.data[modelStr][fnStr];
}

export async function queryAddressDetail(
  rModel: RuntimeModel,
  params: {
    deliveryAddressCopy: Record<any, any>;
  }
) {
  const gql = `
    query {
        deliAriesSellerCreateTmsOrderQuery {
          AddressConstruct(
            data: ${stringifyToGraphql(params)}
          ){
            deliveryAddress {
              id
              contactMan
              contactPhone
              contactLandPhone
              contactEmail
              zipCode
              address {
                id
                street2
                fullAddress
                countryCode
                countryName
                provinceCode
                provinceName
                cityCode
                cityName
                districtName
                districtCode
                streetCode
                streetName
              }
              detailAddress
              addressId
            }
          }
        }
      }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderQuery.AddressConstruct;
}

export async function submitData(rModel: RuntimeModel, params: Record<any, any>) {
  const gql = `
    mutation {
      deliAriesSellerCreateTmsOrderMutation {
        create(
          data: ${stringifyToGraphql(params, enumList)}
        ){
          tradeOrderId
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerCreateTmsOrderMutation.create;
}

/**
 * 查询所有代发方式对应的整散件开关列表
 *
 * @return {*}
 */
export const queryWareHouseDeliveryTypeSwitchList = async () => {
  const gql = `
    query {
      warehouseDeliveryTypePolicyProxyQuery {
        queryActiveList {
          ariesIssuingMethodEnum
          enableWarehouseDeliveryType
        }
      }
    }
  `;
  const res = await http.query<{ ariesIssuingMethodEnum: TIssuingMethod; enableWarehouseDeliveryType: boolean }[]>(
    'libraCore',
    gql
  );
  return res.data.warehouseDeliveryTypePolicyProxyQuery.queryActiveList;
};

/*
 * 获取账户余额
 * */
export const getAccountBalance = async (rModel: RuntimeModel, code: string) => {
  const gql = `
      query {
	      sellerDistributorTradeOrderQuery {
		      queryCurrentBuyerRelationSellerOfficeAllFundBook(data: { code: "${code}" }) {
            sapRemainingAmount
			      disFundBookList {
				      id
				      usableAmount
				      bizType
				      name
				      sameTypeFundUsableAmount
				      fundType
			        }
		        }
	        }
        }
	      `;
  console.log(rModel.moduleName);
  const result = await http.query<any>(rModel.moduleName, gql);
  return result?.data?.sellerDistributorTradeOrderQuery?.queryCurrentBuyerRelationSellerOfficeAllFundBook;
};


/*
 * 获取账户余额
 * */
export const dealOption = async ( data: any[]) => {
    const gql = `
      mutation{
	      sellerDistributionTradeOrderDetailMutation  {
		      dealOption(tradeOrderDetailList: ${stringifyToGraphql(data, enumList)}) {  id }
	        }
	        
        }
	      `;
    const result = await http.query<any>("deliAriesCoreSeller", gql);
    return result?.data?.sellerDistributionTradeOrderDetailMutation?.dealOption;
};
